import React from 'react';
import {
  Controller,
  type Control,
  type UseControllerProps,
} from 'react-hook-form';
import NotesInput, { type NotesInputProps } from './NotesInput';

type ControlledNotesInputProps = NotesInputProps &
  UseControllerProps & {
    control: Control;
    defaultValue?: string;
    name: string;
    onChange?: (value: string) => void;
    required?: boolean;
    value?: string;
  };

export default function ControlledNotesInput({
  control,
  defaultValue,
  label,
  name,
  ...props
}: ControlledNotesInputProps) {
  return (
    <Controller
      {...(defaultValue && { defaultValue })}
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <NotesInput
          {...{
            ...props,
            label,
            notes: value || '',
            setNotes: onChange,
          }}
        />
      )}
    />
  );
}
